import intlTelInput from 'intl-tel-input'

document.querySelectorAll('.intl-tel-input').forEach(input => {
    const config = {
        autoPlaceholder: 'off',
        initialCountry: input.getAttribute('data-initial-country-code'),
        nationalMode: true,
        utilsScript: '/asset2/63fd97bb5854053113365dfd9071ba8f/dist/lib/intl-tel-input/build/js/utils.js'
    }
    if(window.elumeo?.intlTelInputLocale) {
        config.i18n = window.elumeo.intlTelInputLocale
    }
    input.intlTelInputInstance = intlTelInput(input, config)
})